<template>
    <div class="no-data-container">
        <div class="no-data">
            <div>
                <mdicon :name="icon" size="64" />
                <div>
                    <slot name="info"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'no-data',
    props: {
        icon: {
            type: String,
            default: 'mdi-alert-outline'
        },
        fill_height: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>
.no-data-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: var(--nc-spacing-lg);
}

.no-data {
    text-align: center;
    color: var(--nc-text-muted);
}

.no-data .mdi {
    color: var(--nc-color-medium);
    margin-bottom: var(--nc-spacing-sm);
}
</style>
